export enum UserStatusTypeID {
    Pending = 0,
    Approved = 1,
    Blocked = 2,
    Inactive = 4,
    Hold = 5,
    Refused = 6,
}

type BadgeStatus = 'success' | 'processing' | 'default' | 'error' | 'warning';

interface UserStatusBadgeConfig {
    color: string;
    status: BadgeStatus;
}

export const USER_STATUS_BADGE_CONFIG: Record<UserStatusTypeID, UserStatusBadgeConfig> = {
    [UserStatusTypeID.Pending]: { color: 'gold', status: 'warning' },
    [UserStatusTypeID.Approved]: { color: 'green', status: 'processing' },
    [UserStatusTypeID.Blocked]: { color: 'red', status: 'error' },
    [UserStatusTypeID.Inactive]: { color: 'default', status: 'default' },
    [UserStatusTypeID.Hold]: { color: 'orange', status: 'warning' },
    [UserStatusTypeID.Refused]: { color: 'magenta', status: 'error' },
};

export const getUserStatusBadgeConfig = (statusTypeID?: number): UserStatusBadgeConfig => {
    if (statusTypeID !== undefined && statusTypeID in USER_STATUS_BADGE_CONFIG) {
        return USER_STATUS_BADGE_CONFIG[statusTypeID as UserStatusTypeID];
    }

    return { color: 'default', status: 'default' };
};
